<div class="card mt-3">
  <div class="card-header">
    Optimized Portfolio Weights

    <button type="button" class="float-end" mat-flat-button color="primary" (click)="saveWeights()" [disabled]="totalWeight && (totalWeight != 100)">Save & Reload</button>
    <span class="weight-error-label" *ngIf="totalWeight && (totalWeight !== 100)">My Portfolio total weight is not 100%! (<b>{{totalWeight}}</b>%)</span>
  </div>
  <div class="card-body">
    <table mat-table [dataSource]="dataSource" matSort class="w-100 mat-small-table table-with-input table-hover">
      <ng-container *ngFor="let col of optimizedPortfolioWeightsColumns" matColumnDef="{{col.id}}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="col.type == 99" [class.text-end]="col.type == 2 || col.type == 3 || col.textRight" [class.pe-4]="col.type == 2 || col.type == 3 || col.textRight" >
          <span *ngIf="col.type != 99" [class.text-end]="col.type == 2 || col.type == 3 || col.textRight">{{col.label}}</span>
          <span *ngIf="col.type == 99">
            <mat-form-field>
              <mat-label [class.text-end]="col.type == 2 || col.type == 3 || col.textRight">My portfolio source</mat-label>
              <mat-select placeholder="My portfolio source" [(ngModel)]="selectedType" name="selected-type">
                <mat-option *ngFor="let s of selectList" [value]="s.label" (click)="onSelectChange(s.id)">{{s.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </th>

        <td mat-cell *matCellDef="let element" [ngSwitch]="col.type" [class.text-end]="col.type == 2 || col.type == 3 || col.textRight" [class.pe-4]="col.type == 2 || col.type == 3 || col.textRight" >
          <div *ngSwitchCase="1">{{element[col.id]}}</div>
          <div *ngSwitchCase="2">{{(element[col.id]*100)|number:'1.0-2'}}%</div>
          <div *ngSwitchCase="3">{{(element[col.id])|number:'1.0-2'}}<span *ngIf="col.suffix">{{col.suffix}}</span></div>
          <div *ngSwitchCase="4">
            <mat-form-field class="max-100 table-input-suffix" appearance="outline">
              <input matInput type="number" [(ngModel)]="element[col.id]" step="0.1">
              <span matSuffix *ngIf="col.suffix">{{col.suffix}}</span>
            </mat-form-field>
          </div>
          <div *ngSwitchCase="5">
            <span class="underline-on-hover ms-2 text-truncate" (click)="onCompanyInfoClick(element)">{{element[col.id]}}</span>
          </div>

          <div *ngSwitchCase="99">
            <mat-form-field class="max-100 table-input-suffix" appearance="outline">
              <input matInput type="number" [(ngModel)]="element[col.id]" step="0.1" (ngModelChange)="checkWeights()">
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
        </td>

      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnLabels"></tr>
      <tr mat-row *matRowDef="let row; columns: columnLabels;"></tr>

    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
</div>
